import type {
  AppDownloadConfig,
  AppDownloadConfigResponse,
  AppLinkPlatformId,
} from '@/shared/logon/settings';
import { hrApiURL } from '@/lib/api';

const CONFIG_REVALIDATE_SEC = 300;
const API_BASE = hrApiURL || 'http://localhost:8181/api';

export async function getAppDownloadConfig(
  projectKey: string
): Promise<AppDownloadConfig | null> {
  const res = await fetch(
    `${API_BASE}/settings/app-download/${encodeURIComponent(projectKey)}`,
    {
      next: { revalidate: CONFIG_REVALIDATE_SEC },
    }
  );

  if (res.status === 404) {
    return null;
  }

  if (!res.ok) {
    throw new Error(`Failed to load app download config: ${res.status}`);
  }

  const json = (await res.json()) as AppDownloadConfigResponse;
  return json.data;
}

export async function recordAppDownloadClick(
  projectKey: string,
  platformId: AppLinkPlatformId
): Promise<void> {
  const res = await fetch(
    `${API_BASE}/settings/app-download/${encodeURIComponent(projectKey)}/click`,
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ platformId }),
      cache: 'no-store',
    }
  );

  if (!res.ok && res.status !== 204) {
    throw new Error(`Failed to record app download click: ${res.status}`);
  }
}
